<template>
  <div class="container">
    <span class="title">{{ titleOne }}</span>
    <TableOne :politicaGestion="politicaGestion" :readOnly="readOnly" />
  </div>
</template>

<script>
import TableOne from "./components/mainTableEight/TableOne";

export default {
  props:["politicaGestion", "readOnly"],
  components: {
    TableOne,
  },
  data() {
    return {
      //Primary Table
      titleOne: "8 Política de Gestión de Personas formalizada",
      textOne:
        "Tiene Política de Gestión de Personas formalizada vía Resolución (Sí / No)",
      inputOne: "",
      inputTwo: "",
      inputThree: "",
    };
  },
};
</script>

<style scoped>
.title {
  color: #052333;
  font-size: 17px;
  font-weight: bold;
  margin-top: 10px !important;
  margin-bottom: 10px;
}

.container {
  margin-bottom: 10px;
}
</style>
